import { render, staticRenderFns } from "./bindAccessIp.vue?vue&type=template&id=312568b2&scoped=true"
import script from "./bindAccessIp.vue?vue&type=script&lang=js"
export * from "./bindAccessIp.vue?vue&type=script&lang=js"
import style0 from "./bindAccessIp.vue?vue&type=style&index=0&id=312568b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312568b2",
  null
  
)

export default component.exports